export default {
  PessoaFisica: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "pessoa-fisica"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/PessoaFisica.js
// module id = AiUR
// module chunks = 13